import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideLogOut = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m16 17 5-5-5-5m5 5H9m0 9H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLucideLogOut);
const Memo = memo(ForwardRef);
export default Memo;
